import SubmitTestResultRequestModelBase from '../_generated/modelBases/submit-test-result-request-model-base';

export default class SubmitTestResultRequestModel extends SubmitTestResultRequestModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/429/ServiceModels-DTOs
}
